import { RequestError } from '../requestError';
import api from '../axiosBase';
import { getURL } from '../serviceHelper';

export class GroupsService {
  static async getGroups() {
    return api.get(getURL(`/groups`))
      .then(res => res.data.value)
      .catch(err => { throw new RequestError(err) });
  }
}
